import React, {useState} from 'react';
import LoginTab from 'components/login/basic/LoginTab';
import EasyTab from 'components/login/basic/EasyTab';
import 'styles/login/basic/BasicSignIn.css';
import UniversalOptionsList from 'components/universal/UniversalOptionsList';

const initialState = 'Login';

const BasicSignInTab = ({onMissingUserName, handleOtpRequested}) => {
    const [currentTab, setCurrentTab] = useState(initialState);

    const renderCurrentTab = () => {
        switch (currentTab) {
            case 'Login':
                return <LoginTab onOtpRequested={handleOtpRequested} isRegister={false}/>;
            case 'Register':
                return <LoginTab onOtpRequested={handleOtpRequested} isRegister={true}/>;
            case 'Easy':
                return <EasyTab onMissingUserName={onMissingUserName}/>;
            default:
                return null;
        }
    };

    return (
        <div className="smaller-sign-in">
            <div style={{marginTop: '7px'}}>
                <UniversalOptionsList
                    initialOption={initialState}
                    options={['Easy', 'Login', 'Register']}
                    onOptionClick={(option) => setCurrentTab(option)}
                />
            </div>
            {renderCurrentTab()}
        </div>
    );
};

export default BasicSignInTab;
